// Dados compartilhados da landing `/` — usados pela página (SEO/JSON-LD) e
// pelas seções abaixo da dobra (carregadas sob demanda, ver sections.tsx).
//
// REGRA EDITORIAL: tudo aqui é o que a Blink entrega de fato. Nenhum número de
// resultado, contador de pacientes, nota ou depoimento inventado.

export const PRECO = "48,90";

/** Atendente humano (WhatsApp) — fonte única do número e da mensagem padrão: usado
 *  pela bolinha fixa (components/FloatingWhatsApp.tsx), pelo rodapé da landing e pelo
 *  "Como funciona" do cadastro (components/feature/ComoFuncionaCadastro.tsx). */
export const ATENDENTE_FONE = "5554994574953";
export const ATENDENTE_MSG = "Olá! Gostaria de falar com um atendente.";
export const atendenteUrl = (msg: string = ATENDENTE_MSG) =>
  `https://wa.me/${ATENDENTE_FONE}?text=${encodeURIComponent(msg)}`;
export const PRECO_DE = "78,90";

/** Fonte única das dúvidas: o texto da tela E o FAQPage do JSON-LD saem daqui
 *  (dado estruturado nunca diverge do que a pessoa lê — motivo de penalização). */
export const DUVIDAS = [
  { q: "Preciso instalar algum aplicativo?", a: "Não. A consulta abre direto no navegador do celular ou do computador. Você só autoriza câmera e microfone — e, se preferir, pode ser tudo por mensagem." },
  { q: "A receita digital é válida mesmo?", a: "Sim. É assinada com certificado ICP-Brasil pela Memed, o mesmo padrão usado em consultório presencial, e aceita em farmácias de todo o país." },
  { q: "Em quanto tempo eu sou atendido?", a: "No plantão você entra na fila e o próximo médico disponível assume. O tempo varia com a demanda do momento — se preferir hora marcada, dá para agendar com o profissional que você escolher." },
  { q: "O atendimento é sigiloso?", a: "Totalmente. Sigilo médico é obrigação legal e tratamos seus dados conforme a LGPD. Nada do que você disser é compartilhado." },
  { q: "E se eu precisar de um especialista?", a: "Além do clínico geral do plantão, você pode escolher entre as especialidades disponíveis e agendar direto com o médico." },
  { q: "Como eu pago?", a: `PIX ou cartão, direto na página, antes da consulta. São R$ ${PRECO} por consulta — pagamento único, sem mensalidade e sem fidelidade.` },
];
